namespace $.$$ {

	export class $shm_wordstat_filter_panel extends $.$shm_wordstat_filter_panel {

		state() {
			return super.state() as $shm_wordstat_filter_state_store
		}

		queries( next?: string ) {
			return this.state().queries( next )
		}

		query_filter( next?: $shm_wordstat_filter ) {
			return this.state().query_filter( next )
		}

		regions( next?: string ) {
			return this.state().regions( next )
		}

		period_kind( next?: string ) {
			if( next !== undefined ) return this.state().period_kind( next )

			return this.period_kinds_selected()[0] ?? 'PERIOD_MONTHLY'
		}

		period_kinds( next?: $shm_wordstat_filter ) {
			return this.state().period_kinds( next )
		}

		devices( next?: $shm_wordstat_filter ) {
			return this.state().devices( next )
		}

		period( next?: $shm_wordstat_period ) {
			return this.state().period( next )
		}

		Region_select() {
			const obj = super.Region_select()
			obj.select_all_visible = ()=> !this.collecting()
			obj.only_visible = ()=> !this.collecting()
			return obj
		}

		Period() {
			const obj = super.Period() as any
			obj.preset_options = ()=> this.period_preset_options()
			obj.preset_period = ( preset: string )=> this.period_preset_period( preset )
			return obj
		}

		period_kind_primary() {
			return this.period_kinds_selected()[0] ?? this.period_kind()
		}

		period_preset_options() {
			const kind = this.period_kind_primary()
			if( kind === 'PERIOD_MONTHLY' ) return {
				all: 'Весь период (с 2018)',
				current_year: 'Этот год',
				previous_year: 'Прошлый год',
				years5: '5 лет',
			}

			return {
				all: 'Весь период',
				current_month: 'Этот месяц',
				previous_month: 'Прошлый месяц',
			}
		}

		period_date( year: number, month: number, day: number ) {
			return [
				String( year ).padStart( 4, '0' ),
				String( month ).padStart( 2, '0' ),
				String( day ).padStart( 2, '0' ),
			].join( '-' )
		}

		period_days_in_month( year: number, month: number ) {
			return new Date( Date.UTC( year, month, 0 ) ).getUTCDate()
		}

		period_date_parse( date: string ) {
			const match = String( date ).match( /^(\d{4})-(\d{2})-(\d{2})/ )
			if( !match ) return new Date
			return new Date( Number( match[1] ), Number( match[2] ) - 1, Number( match[3] ) )
		}

		period_preset_clamp( period: $shm_wordstat_period ) {
			const all = this.period_all()
			let from = period.from
			let to = period.to
			if( all.from && from < all.from ) from = all.from
			if( all.to && from > all.to ) from = all.to
			if( all.from && to < all.from ) to = all.from
			if( all.to && to > all.to ) to = all.to
			if( from > to ) from = to
			return { from, to }
		}

		period_preset_period( preset: string ) {
			const all = this.period_all()
			const now = new Date
			const anchor = this.period_date_parse(
				all.to || this.period_date( now.getFullYear(), now.getMonth() + 1, now.getDate() ),
			)
			const year = anchor.getFullYear()
			const month = anchor.getMonth() + 1

			if( preset === 'all' ) return all

			if( preset === 'current_year' ) return this.period_preset_clamp({
				from: this.period_date( year, 1, 1 ),
				to: this.period_date( year, 12, 31 ),
			})

			if( preset === 'previous_year' ) return this.period_preset_clamp({
				from: this.period_date( year - 1, 1, 1 ),
				to: this.period_date( year - 1, 12, 31 ),
			})

			if( preset === 'years5' ) return this.period_preset_clamp({
				from: this.period_date( year - 4, 1, 1 ),
				to: this.period_date( year, 12, 31 ),
			})

			if( preset === 'current_month' ) return this.period_preset_clamp({
				from: this.period_date( year, month, 1 ),
				to: this.period_date( year, month, this.period_days_in_month( year, month ) ),
			})

			if( preset === 'previous_month' ) {
				const previous = new Date( Date.UTC( year, month - 2, 1 ) )
				const prev_year = previous.getUTCFullYear()
				const prev_month = previous.getUTCMonth() + 1
				return this.period_preset_clamp({
					from: this.period_date( prev_year, prev_month, 1 ),
					to: this.period_date( prev_year, prev_month, this.period_days_in_month( prev_year, prev_month ) ),
				})
			}

			return this.period()
		}

		period_kind_options() {
			return {
				PERIOD_MONTHLY: 'Месяц',
				PERIOD_WEEKLY: 'Неделя',
				PERIOD_DAILY: 'День',
			} as Record< string, string >
		}

		period_kind_codes() {
			return [ 'PERIOD_DAILY', 'PERIOD_WEEKLY', 'PERIOD_MONTHLY' ]
		}

		device_codes() {
			return [ 'DEVICE_ALL', 'DEVICE_DESKTOP', 'DEVICE_PHONE', 'DEVICE_TABLET' ]
		}

		period_kind_check_rows() {
			return this.period_kind_codes().map( period => this.collecting()
				? this.Period_kind_check( period )
				: this.Period_kind_radio( period )
			)
		}

		period_kind_title( period: string ) {
			return this.period_kind_options()[ period ] ?? period
		}

		period_kind_checked( period: string, next?: boolean ) {
			if( !this.period_kind_enabled( period ) ) return false
			const filter = this.period_kinds()
			if( next === undefined ) return this.collecting()
				? filter[ period ] ?? false
				: this.period_kind() === period
			if( !this.collecting() ) {
				if( next ) {
					this.state().period_kind_period( period, this.period_all_kind( period ) )
					return true
				}
				return filter[ period ] ?? false
			}
			this.period_kinds({ ... filter, [ period ]: next })
			return next
		}

		period_kind_enabled( period: string ) {
			const allowed = this.period_kind_available()
			return this.collecting() || !allowed.length || allowed.includes( period )
		}

		period_kinds_selected() {
			const allowed = this.period_kind_available()
			const selected = this.period_kind_codes()
				.filter( period => !allowed.length || allowed.includes( period ) )
				.filter( period => this.period_kinds()[ period ] )
			return this.collecting() ? selected : selected.slice( 0, 1 )
		}

		panel_title() {
			return this.collecting() ? 'Сбор' : 'Фильтры'
		}

		filter_rows() {
			return [
				this.collecting() ? null : this.Period_section(),
				this.period_kind_visible() ? this.Period_kind_section() : null,
				this.query_visible() ? this.Query_section() : null,
				this.device_visible() ? this.Devices_section() : null,
				this.region_visible() ? this.Region_select() : null,
			].filter( Boolean ) as readonly $mol_view[]
		}

		foot_rows() {
			if( !this.collecting() ) return []
			return [ this.Run() ]
		}

		query_content() {
			return this.collecting() ? [ this.Queries() ] : [ this.Query_checks() ]
		}

		query_title_content() {
			return this.collecting()
				? [ this.Query_title(), this.Query_hint() ]
				: [ this.Query_title(), this.Query_all() ]
		}

		query_hint() {
			const count = new Set( String( this.queries() ).split( /\n+/ ).map( value => value.trim() ).filter( Boolean ) ).size
			return `Каждый запрос с новой строки · ${ count }/${ this.query_limit() }`
		}

		query_check_rows() {
			return this.query_available().map( query => this.Query_row( query ) )
		}

		query_group_checks() {
			return this.query_available().map( query => this.Query_check( query ) )
		}

		query_title( query: string ) {
			return query
		}

		Query_row( query: string ) {
			const obj = super.Query_row( query )
			obj.sub = ()=> this.query_row_content( query )
			return obj
		}

		query_row_content( query: string ) {
			return [ this.Query_check( query ), this.Query_only( query ) ]
		}

		query_checked( query: string, next?: boolean ) {
			const filter = this.query_filter()
			if( next === undefined ) return filter[ query ] ?? true
			this.query_filter({ ... filter, [ query ]: next })
			return next
		}

		query_only( query: string, next?: Event ) {
			if( next === undefined ) return null
			this.query_filter( Object.fromEntries(
				this.query_available().map( item => [ item, item === query ] ),
			) )
			return next
		}

		device_checked( device: string, next?: boolean ) {
			if( !this.device_enabled( device ) ) return false
			const devices = this.devices()
			if( next === undefined ) return devices[ device ] ?? false
			this.devices({ ... devices, [ device ]: next })
			return next
		}

		device_enabled( device: string ) {
			const allowed = this.device_available()
			return this.collecting() || !allowed.length || allowed.includes( device )
		}

		device_all( next?: boolean ) {
			return this.device_checked( 'DEVICE_ALL', next )
		}

		device_all_enabled() {
			return this.device_enabled( 'DEVICE_ALL' )
		}

		device_group_checks() {
			const checks: $mol_check[] = []
			if( this.device_all_enabled() ) checks.push( this.Device_all() )
			if( this.device_desktop_enabled() ) checks.push( this.Device_desktop() )
			if( this.device_phone_enabled() ) checks.push( this.Device_phone() )
			if( this.device_tablet_enabled() ) checks.push( this.Device_tablet() )
			return checks
		}

		device_desktop( next?: boolean ) {
			return this.device_checked( 'DEVICE_DESKTOP', next )
		}

		device_desktop_enabled() {
			return this.device_enabled( 'DEVICE_DESKTOP' )
		}

		device_phone( next?: boolean ) {
			return this.device_checked( 'DEVICE_PHONE', next )
		}

		device_phone_enabled() {
			return this.device_enabled( 'DEVICE_PHONE' )
		}

		device_tablet( next?: boolean ) {
			return this.device_checked( 'DEVICE_TABLET', next )
		}

		device_tablet_enabled() {
			return this.device_enabled( 'DEVICE_TABLET' )
		}

		filter_reset( next?: Event ) {
			if( next === undefined ) return null
			this.state().reset()
			if( !this.collecting() ) {
				this.period_kinds( this.period_kinds_reset() )
				this.devices( this.devices_reset() )
				this.regions( this.region_available().join( '\n' ) )
				this.period( this.period_all() )
			}
			return next
		}

		period_kinds_reset() {
			const allowed = this.period_kind_available()
			const next = allowed.includes( 'PERIOD_MONTHLY' )
				? 'PERIOD_MONTHLY'
				: allowed.includes( 'PERIOD_DAILY' )
					? 'PERIOD_DAILY'
					: allowed.includes( 'PERIOD_WEEKLY' )
						? 'PERIOD_WEEKLY'
						: 'PERIOD_MONTHLY'
			return Object.fromEntries(
				this.period_kind_codes().map( period => [ period, period === next ] ),
			) as $shm_wordstat_filter
		}

		devices_reset() {
			const available = this.device_available()
			return Object.fromEntries(
				this.device_codes().map( device => [ device, available.includes( device ) ] ),
			) as $shm_wordstat_filter
		}

	}

}
